/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { WebAppGetYoutubeIntegrationStatsCountryViewersQueryResponse, WebAppGetYoutubeIntegrationStatsCountryViewersPathParams, WebAppGetYoutubeIntegrationStatsCountryViewersQueryParams, WebAppGetYoutubeIntegrationStatsCountryViewers401, WebAppGetYoutubeIntegrationStatsCountryViewers403 } from "../models/WebAppGetYoutubeIntegrationStatsCountryViewers";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { webAppGetYoutubeIntegrationStatsCountryViewers } from "../axios/webAppGetYoutubeIntegrationStatsCountryViewers";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const webAppGetYoutubeIntegrationStatsCountryViewersQueryKey = (station: WebAppGetYoutubeIntegrationStatsCountryViewersPathParams["station"], params: WebAppGetYoutubeIntegrationStatsCountryViewersQueryParams) => ["api-v2", { url: '/web-app/v1/youtube-stats/viewers/:station/country', params: {station:station} }, ...(params ? [params] : [])] as const

export type WebAppGetYoutubeIntegrationStatsCountryViewersQueryKey = ReturnType<typeof webAppGetYoutubeIntegrationStatsCountryViewersQueryKey>

export function webAppGetYoutubeIntegrationStatsCountryViewersQueryOptions(station: WebAppGetYoutubeIntegrationStatsCountryViewersPathParams["station"], params: WebAppGetYoutubeIntegrationStatsCountryViewersQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = webAppGetYoutubeIntegrationStatsCountryViewersQueryKey(station, params)
        return queryOptions<WebAppGetYoutubeIntegrationStatsCountryViewersQueryResponse, ResponseErrorConfig<WebAppGetYoutubeIntegrationStatsCountryViewers401 | WebAppGetYoutubeIntegrationStatsCountryViewers403>, WebAppGetYoutubeIntegrationStatsCountryViewersQueryResponse, typeof queryKey>({
         enabled: !!(station&& params),
         queryKey,
         queryFn: async ({ signal }) => {
            return webAppGetYoutubeIntegrationStatsCountryViewers(station, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Returns stats for every channel in the live-viewers catalog whose `countryCode` matches this station’s channel. `metadata.channels[*].isSelf` marks this station’s `youtubeChannelId`.
 * @summary Viewer time series for same-country catalog channels
 * {@link /web-app/v1/youtube-stats/viewers/:station/country}
 */
export function useWebAppGetYoutubeIntegrationStatsCountryViewers<TData = WebAppGetYoutubeIntegrationStatsCountryViewersQueryResponse, TQueryData = WebAppGetYoutubeIntegrationStatsCountryViewersQueryResponse, TQueryKey extends QueryKey = WebAppGetYoutubeIntegrationStatsCountryViewersQueryKey>(station: WebAppGetYoutubeIntegrationStatsCountryViewersPathParams["station"], params: WebAppGetYoutubeIntegrationStatsCountryViewersQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<WebAppGetYoutubeIntegrationStatsCountryViewersQueryResponse, ResponseErrorConfig<WebAppGetYoutubeIntegrationStatsCountryViewers401 | WebAppGetYoutubeIntegrationStatsCountryViewers403>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? webAppGetYoutubeIntegrationStatsCountryViewersQueryKey(station, params)
         

         const query = useQuery({
          ...webAppGetYoutubeIntegrationStatsCountryViewersQueryOptions(station, params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<WebAppGetYoutubeIntegrationStatsCountryViewers401 | WebAppGetYoutubeIntegrationStatsCountryViewers403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}